<template>
  <v-dialog v-model="dialog" max-width="290" style="width: 100%">
    <slot slot="activator"></slot>
    <v-card>
      <v-card-text>
        <v-text-field class="mb-3" v-model="currentLabel.name" :error-messages="errorMessages('name')" label="Title"></v-text-field>
        <v-layout row>
          <v-flex xs6>
            <h5 class='px-0'>Background color</h5>
            <input type="color" v-model="currentLabel.color" />
            <div class="sl_custom__error">{{ errorMessages('color')[0] }}</div>
          </v-flex>
          <v-flex xs6>
            <h5 class='px-0'>Text color</h5>
            <input type="color" v-model="currentLabel.text_color" />
            <div class="sl_custom__error">{{ errorMessages('text_color')[0] }}</div>
          </v-flex>
        </v-layout>
        <v-btn @click="save" class="mt-3" block color="info">save</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import * as mixins from '@/mixins'

  export default {
    name: 'PaymentsForm',
    mixins: [mixins.errors, mixins.preloader],
    props: {
      'label': {
        type: Object,
        default() {
          return {
            name: '',
            amount: '',
            date: '',
            project_id: this.$route.params.project_id
          }
        }
      },
    },
    data() {
      return {
        dialog: false,
        errors: {},
        api: this.$api.labels,
        currentLabel: {
          name: '',
          amount: '',
          date: '',
          project_id: this.$route.params.project_id,
        },
      }
    },
    methods: {
      open() {
        this.dialog = true
      },
      editLabel() {
        this.errors = {}
        return this.api.save(this.currentLabel).then(response => {
          this.$emit('update')
          this.dialog = false
        }, response => {
          this.errors = response.errors
        })
      },
      save() {
        this.background(this.editLabel())
      }
    },
    watch: {
      dialog(newValue, oldValue) {
        if (newValue && newValue !== oldValue && this.label) {
          this.currentLabel = JSON.parse(JSON.stringify(this.label));
        }
      }
    }
  }
</script>
